/**
 * SAP CONFIDENTIAL
 *
 * This software is confidential proprietary software licensed by SAP SE
 * and is not to be used, duplicated or disclosed to anyone without the
 * prior written permission of SAP.
 *
 * (C) 2020 Copyright SAP SE.
 */
import { BsDatepickerConfig } from "ngx-bootstrap/datepicker";

export class RateCardModel {
  id!: string;
  bonusName?: any;
  compensationPlan: any = { id: '' };
  editable?: boolean;
  evaluation = '';
  evaluationType?: any = {  code: '', name: '' };
  flags?: any[] = [];
  existingFlags?: any[] = [];
  flagDefinitions: any[] = [];
  globalCompType?: any;
  isNoCompRateRegionCards? = false;
  mlmOverride?: any = { id: '', code: '' };
  name!: string;
  operation? = 'Create';
  operationIndex?: number;
  overrides? = [];
  plan: any[] = [];
  ruleError? = { userMessage: '' };
  titles? = [];
  titleType: any = { id: '' };
  titleTypes? = [];
  viewMode? = false;
  volumeCode!: string;
  volumeType: any;
  volumeTypes? = [];
  compRateRegionCards: Array<CompRateRegionCard> = [];
  isCopied:any;
}

export class CompRateRegionCard {
  id?: any;
  name:any;
  operation = 'Create';
  operationIndex?: number;
  personalBonus?: PersonalBonus;
  region: any = { code: '' };
  closeRate = false;
  closeRateToDate?: number;
  fromDate?: any;
  formattedFromDate: any;
  toDate?: any;
  uniqueId!: string;
  formattedToDate: any;
  fromDatePickerOptions?: Partial<BsDatepickerConfig>;
  toDatePickerOptions?: Partial<BsDatepickerConfig>;
  isRateCardCopied = false;
  branchManagerBonus?: BranchManagerBonus;
  developmentBonus?: DevelopmentBonus;
  seniorTeamLeaderBonus!: SeniorTeamLeaderBonus;
  teamLeaderBonus?: TeamLeaderBonus;
  teamLeaderTargetBonus?: TeamLeaderTargetBonus;
  newComerCommission?: NewcomerCommissionBonus;
  compRateCardChannelUnits?: Array<ChannelUnit> = [];
  compRateCardChannelUnit!:ChannelUnit;
  cumulativeRateCard?: CumulativeUnit;
  linealRateCard?: LinealUnit;
  recruitmentRateCard?: RecruitmentBonus;
  eventRateCard!: EventRateBonus;
  dependentRateCard!: DependentRateBonus;
  newComerEPRateCard?: NewComerEPBonus;
  unitRangeRateCard?: CumulativeUnit;
  recruitRateCard?: RecruitmentBonusPL;
  newcomerSuperCommission?:NewcomerCommissionBonusPL;
  performanceStandardCommission?: PerformanceStandardCommission;
  compRateCardActivityBonus?: ActivityCommissionBonus;
  criteriaRateCard!:CriteriaRateBonus;
  volumeCode?: string;
  criteriaBasedRateCard!:CriteriaBasedRateCard
}

export class PerformanceStandardCommission {
  id?: string | number;
  operationIndex?: number;
  operation = 'Create';
  performanceStandardCommissionRates: Array<PerformanceStandardCommissionRate> = [];
}

export class PerformanceStandardCommissionRate {
  id?: string | number;
  operationIndex?: number;
  operation = 'Create';
  fixedAmount!: any;
  rateType:string = '';
  titles: any[] = [];
  fixedAmounterrorMsg?: string;
  fixedAmountIsTwoDecimalError?: boolean;
  endLimitErrorMsg?: string;
  endLimitIsGreaterError?: boolean;
}

export class DependentRateBonus {
  id?: string | number;
  operation = 'Create';
  operationIndex?: number;
  amount!: number;
  count!: number;
  periods!:number;
}

export class EventRateBonus {
  id?: string | number;
  operation = 'Create';
  operationIndex?: number;
  rateType!: 'Fixed' | 'Unit' | 'Criteria';
  fixedAmount!: any;
  enableUnit = false;
  rateSubType = false;
  subType: any = '';
  overTheUnit!: any;
  productCodes: any[] = [];
  unitRates: Array<PersonalBonusRate> = [];
  criteriaRates: Array<CriteriaRate> = [];
  sourceTitles: any[] = [];
  targetTitles: any[] = [];
  mtlActivePeriods?: any;
}

export class CriteriaRateBonus {
  id?: string | number;
  operation = 'Create';
  operationIndex?: number;
  amount!: number;
  mtlActivePeriods!:number;
  periods!:number;
  rePromotionPeriod!:number;
  sourceTitles: any[] = [];
  existingSourceTitles: any = { id: [] };
  targetTitles: any[] = [];
  existingTargetTitles: any = { id: [] };
  criteriaRates: Array<CriteriaRateModal> = [];
  hasCriteriaError?:any;
  totalOnFile!:number;
}
export class CriteriaBasedRateCard {
  id?: string | number;
  operation = 'Create';
  operationIndex?: number;
  expressionRuleRates: Array<ExpressionRuleRates>=[];
  hasExpressionError?:any;
}
export class ExpressionRuleRates {
  id?: string | number;
  operation = 'Create';
  operationIndex?: number;
  titles: any[] = [];
  expressionRates: Array<ExpressionRates>=[];
  isDemotionFlag: boolean = false;
  periodCount?: number;
  requiredTmbCount?: number;
}

export class ExpressionRates {
  id?: string | number;
  operation = 'Create';
  operationIndex?: number;
  amount!: number;
  expressionRuleSet!: ExpressionRules;
}

export class ExpressionRules {
  id?: string | number;
  operation = 'Create';
  operationIndex?: number;
  isExpressionRulesEmpty?:false;
  expressionRules: Array<ExpressionCriteria> = [];
}

export class ExpressionCriteria {
  id: any;
  operation = 'Create';
  operationIndex?: number;
  criteriaType: any = '';
  criteria: any = '';
  operator: any = '';
  value: any = '';
  startOperator: any = '';
  endOperator: any = '';
  criteriaDisplay?: any = '';
  criteriaTypeDisplay?: any = '';
  operatorsArray?: Array<any> = [];
  criteriaArray?: Array<any> = [];
  existingTitles: any[] = []; // For Titles multi-select
  flagValues?: any[] = [];
  flagDescription?: any = '';
  isValueDisabled?: boolean = false;
}

export class CriteriaRateModal {
  id: any;
  operation = 'Create';
  operationIndex?: number;
  criteriaType: any = '';
  criteria: any = '';
  operator: any = '';
  value: any = '';
  criteriaDisplay?: any = '';
  criteriaTypeDisplay?: any = '';
  operatorsArray?: Array<any> = [];
  criteriaArray?: Array<any> = [];
}

export class CriteriaRate {
  id?: string | number;
  operationIndex?: number;
  operation = 'Create';
  keyMetricCode = '';
  amount!: number;
  quantity!: number;
  value!:number;
  allignsTo = '';
  allignsToLength !: number;
}

export class RecruitmentBonus {
  id?: string | number;
  operation = 'Create';
  operationIndex?: number;
  titles: any[] = [];
  keyMetric!: string;
  type = '';
  recruitmentRates: Array<RecruitmentRate> = [];
}

// the below fields applicable for poland data (VCE-15106)
export class RecruitmentBonusPL {
  id?: string | number;
  operation = 'Create';
  operationIndex!: number;
  recruitRates: Array<RecruitRate> = [];
}

export class RecruitRate {
  orderDateValidity!: number;
  id?: string | number;
  operationIndex?: number;
  operation = 'Create';
  commissionDateValidity!: number;
  evaluationDelay!: number;
  unitRates: Array<PersonalBonusRate> = [];
  rateType: any = '';
  rangeRates: Array<RangeRate> = [];
  enableUnit = false;
  overTheUnit!: any;
  fixedAmount!: number;
  titles: any[] = [];
  valueChainRates: Array<ValueChainRate> = [];
  epactLimit!: number;
  rcbOrderDuration?: number;
}

export class RecruitmentRate {
  id?: string | number;
  operationIndex?: number;
  operation = 'Create';
  conditionIds: any[] = [];
  productCodes: any[] = [];
  amount!: number;
  unit!: number;
  titles:any[] = []
  existingTitles: any = { id: [] };
}

export class LinealUnit {
  id?: string | number;
  operationIndex?: number;
  operation = 'Create';
  productCodes: any[] = [];
  titles: any[] = [];
  unitRates: Array<PersonalBonusRate> = [];
}

export class CumulativeUnit {
  id?: string | number;
  operationIndex?: number;
  operation = 'Create';
  cumulativeRates: Array<CumulativeRate> = [];
  includeMaterial!: boolean;
  materialRule?: MaterialRule = new MaterialRule();
  conditionIds: any[] = [];
}

export class MaterialRule {
  filteredMaterials?: any[] = [];
  productCodes: any[] = [];
  productCategories:any[] = [];
  existingProductCategories:any;
  selectionByMaterialOrMaterialGroup: string = '';
}

export class CumulativeRate {
  id?: string | number;
  operationIndex?: number;
  operation = 'Create';
  enableUnit = false;
  overTheUnit!: any;
  rateType = '';
  titles: any[] = [];
  unitRates: Array<PersonalBonusRate> = [];
  rangeRates: Array<RangeRate> = [];
  rangeFlatRates: Array<RangeRate> = [];
  rateSubType = false;
  subType: any = '';
  amountPerUnit !: boolean;
  expressionRuleSet!: ExpressionRuleSet;
  percentageRateType = '';
  unitPercentageRates: Array<PersonalBonusRate> = [];
  rangePercentageRates:Array<RangeRate> = [];
  excludeMaterialConfiguration: ExcludeMaterialConfiguration = new ExcludeMaterialConfiguration();
  enableSetAside? = false;
  epPeriodPCBbonus: boolean = false;
  challengeProgram: any[] = [];
}

export class CreateActivityMinBonusRate {
  minValue: number | null = null;
  amount: number | null = null;

  // Validation flags
  minValueError?: boolean = false;
  amountError?: boolean = false;
}

export class ActivityBonusRate {
  id?: string | number;
  operationIndex?: number;
  operation = 'Create';
  titles: any[] = [];
  activityBonus: CreateActivityMinBonusRate[] = [];
}
export class ActivityCommissionBonus {
  id?: string | number;
  operationIndex?: number;
  operation = 'Create';
  activityBonusRates: ActivityBonusRate[] = [];
}

export class ExcludeMaterialConfiguration {
  id?: string | number;
  operationIndex?: number;
  operation = 'Create';
  materialConfiguration: Array<MaterialConfiguration> = [];
  existingMaterialConfiguration?: Array<MaterialConfiguration> = [];
  filteredMaterials?:any;
}

export class MaterialConfiguration {
  code!:string;
  name!: string;
  conditionIds: any[] = [];
  isSelected?: Boolean;
}

export class RangeRate {
  id?: string | number;
  operationIndex?: number;
  operation = 'Create';
  startLimit!: any;
  endLimit: any;
  value!: number;
  setAsideAmount?: number;
}

export class ChannelUnit {
  id?: string | number;
  operationIndex?: number;
  operation = 'Create';
  titleLimits: Array<ChannelTitleLimit> = [];
  materials: Array<ValueChainMaterial> = [];
  fullPrice!: number;
  compRateCardAdditionalConfiguration:any = { id: '', bcbCPLimit: '' };
  baseValueChainMaterial?: BaseValueChainMaterial = new BaseValueChainMaterial();
  exceptionValueChainMaterials: Array<ExceptionValueChainMaterial> = [];
  titles: any[]=[];
  existingTitles: any = { id: [] };
  isExceptionExpanded: boolean = false;
  isExceptionExpandedView:boolean = false;
  uniqueTimestamp: any;
  cpProgram: boolean = false;
}
export class CompRateCardActivityBonus {
  id?: string | number;
  operationIndex?: number;
  operation = 'Create';
  minValue: number = 0;
  amount: number = 0;
  createdDate?: number;
  titles: any[] = [];
  existingTitles: any = { id: [] };
  rateLimitIsTwoDecimalError = false;
  isExpanded = false;
  uniqueTimestamp: any = new Date().getTime();
}

export class BaseValueChainMaterial {
  id?: string | number;
  operation!: 'Create';
  operationIndex?: number;
  rate!: number;
  reducedRate?: number;
  selectionByMaterialOrMaterialGroup: string = 'Material Group';
  rateCardType: string = 'BaseRateCard';
  productCodes!: any[];
  titles!: any[];
  valueChainRates: Array<ValueChainRate> = [];
  keyMetricRules: Array<KeyMetricModel> =[];
  productCategories?: Array<ProductCategory> = [];
  materialGroups?:  Array<MaterialGroup> = [{ id: 0, groupCode: '', name: '' }];
  existingMaterials?: Array<ProductCategory> = [];
  existingMaterialGroups?: Array<MaterialGroup> = [];
  rateerrorMsg!: string;
  rateIsTwoDecimalError!: boolean;
  endLimitErrorMsg!: string;
  endLimitIsGreaterError!: boolean;
  reducedRateerrorMsg!: string;
  reducedRateIsTwoDecimalError!: boolean;
  cumulativeRateCard?: CumulativeUnit;
  sep1reducedLimit?: number;
  sep1reducedAmount?: number;
}

export class ProductCategory {
  id!: number;
  code!: string;
  name!: string;
  isSelected?: Boolean;
}

export class MaterialGroup {
  id!: number;
  groupCode!: string;
  isSelected?: Boolean;
  name!: string;
}

export class ExceptionValueChainMaterial {
  operation = 'Create';
  operationIndex?: number;
  uniqueId!: string;
  priorityRank!: number;
  fromDate!: any;
  formattedFromDate: any;
  toDate!: any;
  formattedToDate: any;
  fromDatePickerOptions?: Partial<BsDatepickerConfig>;
  toDatePickerOptions?: Partial<BsDatepickerConfig>;
  valueChainMaterial: BaseValueChainMaterial = new BaseValueChainMaterial();
  exceptionRateActive:boolean = true;
  fromDateInClosedPeriod:boolean = false;
  rateCardValid: boolean = true; //to show inactive badge in exception rate cards
  isMaterialExpanded: boolean = false;
}

export class ProductCategories {
  id?: String | number;
  code?: String;
  name?: String;
  isSelected?: Boolean;
}

export class ChannelTitleLimit {
  id?: string | number;
  operationIndex?: number;
  operation = 'Create';
  titles: any[] = [];
  productCodes: any[] = [];
  rateLimit!: number;
}

export class ValueChainMaterial {
  id?: string | number;
  operationIndex?: number;
  operation = 'Create';
  productCodes: any[] = [];
  titles?: any[] = [];
  rate!: number;
  reducedRate?: number;
  valueChainRates: Array<ValueChainRate> = [];
  keyMetricRules: Array<KeyMetricModel> = [];
  cumulativeRateCard?: any;
}

export class ValueChainRate {
  id?: string | number;
  operationIndex?: number;
  operation = 'Create';
  condition = '';
  rateType = '';
  factor!: any;
  amount!: number;
  reducedAmount!: number;
  rateTypeFixedOrItemPercentage = '';
  setFactor!:any;
  setAmount!:any;
  setReducedAmount!:any;
}

export class KeyMetricModel {
  id?: string | number;
  operationIndex?: number;
  operation? = 'Create';
  name!: string;
  value!: number;
  metricRuleForPositiveOrdersOnly!: boolean;
}

export class PersonalBonus {
  id?: string | number;
  payPeriods = 0;
  rateType!: string;
  rates: Array<PersonalBonusRate> = [];
  value!: any;
  operation? = 'Create';
}

export class PersonalBonusRate {
  id?: string | number;
  startPeriod!: any;
  value!: number;
  setAsideAmount?: number;
  newComersCount?: number;
  operationIndex?: number;
  operation? = 'Create';
}
export class activityBonus {
  id?: string | number;
  amonut: any;
  operation? = 'Create';
}

export class DifferentialRuleModel {
  id!: string;
  titleType: any = { id: '' };
  minTitle: any = { id: '' };
  minimumValue: any;
  rate: any;
  qualifiedLeader: any;
}

export class GenerationalRuleModel {
  id!: string;
  title: any = { id: '' };
  derivativeRate: any = '';
  firstGenRate = '';
  secondGenRate = '';
  thirdGenRate = '';
  fourthGenRate = '';
  fifthGenRate = '';
  sixthGenRate = '';
  flag: FlagConfigObj = new FlagConfigObj();
}

export class CommisionRateRuleModel {
  id!: string;
  title: any = { id: '' };
  volume = '';
  commissionRate!: string;
  kickerVolume = '';
  kickerRate: any;
  qualifiedLeader!: boolean;
}

export class FlagConfigObj {
  flagDefinition: any = { id: '' };
  flagValue: any = { id: [] };
}

export class DirectedBonusRuleModel {
  id!: string;
  source!: string;
  value!: string;
  directedId!: string;
}

export class DirectPaymentRuleModel {
  id!: string;
  currencyType!: string;
  value!: string;
}

export class FixedRatesModel {
  startPeriod!: number;
  value!: number;
}

export class PersonalPerUnitRataCardBonus {
  fixedRates: Array<any> = [];
  fixedOrdersCount!: number;
  flexibleRateValue!: number;
  rateType!: string;
}

export class DevelopmentBonus {
  id!: string;
  payPeriods!: number;
  rateType!: string;
  limitType!: string;
  rates!: Array<DevelopmentBonusRate>;
  operation = 'Create';
}

export class DevelopmentBonusRate {
  id: any;
  startLimit!: number;
  endLimit: any;
  value!: number;
  minVolume!: number;
  operation = 'Create';
  operationIndex?: number;
}

export class TeamLeaderBonus {
  id!: string;
  rateType!: string;
  limitType!: string;
  rates!: Array<TeamLeaderBonusRate>;
  operation = 'Create';
  operationIndex?: number;
}

export class TeamLeaderBonusRate {
  id?: any;
  startLimit!: number;
  endLimit!: string;
  value!: number;
  operation = 'Create';
  operationIndex?: number;
}

export class TeamLeaderTargetBonus {
  id!: string;
  rateType!: string;
  limitType!: string;
  rates: Array<TeamLeaderTargetBonusRate> = [];
  operation = 'Create';
  operationIndex?: number;
}

export class TeamLeaderTargetBonusRate {
  id?: any;
  startLimit!: number;
  endLimit!: string;
  value!: number;
  operation = 'Create';
  operationIndex?: number;
}

export class NewcomerCommissionBonus {
  id!: string;
  rateType!: string;
  limitType!: string;
  rates: Array<NewcomerCommissionBonusRate> = [];
  operation = 'Create';
  operationIndex?: number;
}

export class NewcomerCommissionBonusPL {
  id?: string | number;
  operation = 'Create';
  operationIndex!: number;
  rates: Array<NewcomerCommissionBonusRate> = [];
  newcomerRates: Array<NewComerRate> = [];
  newcomerDownlineRate: Array<NewComerDownline> = [];
}

export class NewComerRate {
  orderDateValidity!: number;
  id?: string | number;
  operationIndex?: number;
  operation = 'Create';
  commissionDateValidity!: number;
  evaluationDelay!: number;
  unitRates: Array<PersonalBonusRate> = [];
  rateType: any = '';
  rangeRates: Array<RangeRate> = [];
  durationIn: any = '';
  fixedAmount!:any;
  titles: any[] = [];
  recruitmentTypes: any[] = [];
  units?: number;
  valueChainMaterialRules:Array<ValueChainMaterialRule>=[];
}
export class ValueChainMaterialRule {
  id?: string;
  operationIndex?: number;
  operation? = 'Create';
  condition = '';
  materialGroupName = '';
  filteredMaterials?: any[] = [];
  productCodes: any[] = [];
  existingProductCodes: any = { id: [] };
}

export class NewComerDownline {
  id?: string | number;
  operationIndex?: number;
  operation = 'Create';
  titles: any[] = [];
  minValue!: number;
}

export class NewcomerCommissionBonusRate {
  id?: any;
  startLimit!: number;
  endLimit!: string;
  value!: number;
  operation = 'Create';
  operationIndex?: number;
}

export class BranchManagerBonus {
  id!: string;
  rateType!: string;
  limitType!: string;
  rates!: Array<BranchManagerBonusRate>;
  operation = 'Create';
  operationIndex?: number;
}

export class BranchManagerBonusRate {
  id?: any;
  startLimit!: number;
  endLimit!: string;
  basicUnits!: number;
  value!: number;
  operation = 'Create';
  operationIndex?: number;
}

export class SeniorTeamLeaderBonus {
  id!: string;
  rateType!: string;
  limitType!: string;
  rates!: Array<SeniorTeamLeaderBonusRate>;
  operation = 'Create';
  operationIndex?: number;
}

export class SeniorTeamLeaderBonusRate {
  id?: any;
  startLimit!: number;
  endLimit!: string;
  value!: number;
  operation = 'Create';
  operationIndex?: number;
}

//new comer EPB
export class NewComerEPBonus {
  id?: string | number;
  operationIndex?: number;
  operation = 'Create';
  newComerEPBRates: Array<NewComerEPRate> = [];
}

export class NewComerEPRate {
  id?: string | number;
  operationIndex?: number;
  operation = 'Create';
  rateType = '';
  titles: any[] = [];
  productCodes: any[] = []
  unitRates: Array<PersonalBonusRate> = [];
  rangeRates: Array<RangeRate> = [];
  isMaterialExpanded: boolean = false;
  isMaterialExpandedView: boolean = false;
  criteria?:string | number='';
}

export class TitlesMaterialGroupObject {
  id: any;
  singleSelect!: string;
  multiSelect: Array<string> = [];
}

export class ExpressionRuleSet {
  id?: string | number;
  operation = 'Create';
  operationIndex?: number;
  expressionRules: Array<Criteria> = [];
}

export class Criteria {
  id: any;
  operation = 'Create';
  operationIndex?: number;
  criteriaType: any = '';
  criteria: any = '';
  operator: any = '';
  value: any = '';
  startOperator: any = '';
  endOperator: any = '';
  // endOperatorDisplay?: any = '';
  // startOperatorDisplay?: any = '';
  criteriaDisplay?: any = '';
  criteriaTypeDisplay?: any = '';
  operatorsArray?: Array<any> = [];
  criteriaArray?: Array<any> = [];
}
